// src/pages/AboutPage.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './AboutPage.css';

const AboutPage = () => {
  const navigate = useNavigate();

  // Function to handle navigation with scroll to top
  const handleLinkClick = (path) => {
    // Navigate to the page
    navigate(path);
    
    // Scroll to top of the page
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Function for shop now button
  const handleShopNowClick = () => {
    navigate('/products');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Function for contact us button
  const handleContactClick = () => {
    navigate('/contact');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">About InAndOutDC</h1>
            <p className="hero-subtitle">
              Washington DC's premier I-71 compliant cannabis dispensary and delivery service, bringing quality, convenience, and compliance to your doorstep.
            </p>
            {/* <div className="hero-badge">Fully Licensed & Compliant</div> */}
          </div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="section mission-section">
        <div className="container">
          <div className="mission-content">
            <div className="mission-icon">🌿</div>
            <h2 className="section-title">Our Mission</h2>
            <p className="mission-text">
              At InAndOutDC, we're revolutionizing cannabis access in the nation's capital. Our mission is to provide safe, premium-quality cannabis products with unparalleled convenience and discretion, operating in full compliance with DC's Initiative 71 regulations.
            </p>
          </div>
        </div>
      </section>

      {/* i71 Compliance Information */}
      <section className="section compliance-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Initiative 71 Compliance</h2>
            <p className="section-subtitle">
              Understanding Washington DC's cannabis laws
            </p>
          </div>

          <div className="compliance-grid">
            <div className="compliance-card legal">
              <div className="card-icon">⚖️</div>
              <h3>What's Legal</h3>
              <ul className="compliance-list">
                <li>InAndOutDC operates in full compliance with Washington DC's Initiative 71. We provide cannabis as a gift with the purchase of products, ensuring all transactions are conducted within the boundaries of DC law.</li>
                
              </ul>
            </div>

            <div className="compliance-card restrictions">
              <div className="card-icon">🚫</div>
              <h3>Important Restrictions</h3>
              <ul className="compliance-list">
                <li>No public consumption</li>
                <li>No driving under the influence</li>
                <li>No consumption in federal parks or buildings</li>
              </ul>
            </div>
          </div>

          <div className="compliance-note">
            <div className="note-icon">ℹ️</div>
            <div className="note-content">
              <h3>Legal Compliance</h3>
              <p>All operations conducted within Initiative 71 guidelines. Cannabis is provided as a gift with purchase of legal items.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="section how-it-works">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">How Our Service Works</h2>
            <p className="section-subtitle">Legal, safe, and convenient delivery</p>
          </div>

          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Browse & Select</h3>
                <p>
                  Explore our premium selection of cannabis products. 
                  Each item comes with a free gift in accordance with I-71.
                </p>
              </div>
            </div>

            <div className="step-card">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Age Verification</h3>
                <p>
                  Provide valid government-issued ID showing you're 21+. 
                  We verify all customers before processing orders.
                </p>
              </div>
            </div>

            <div className="step-card">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Compliant Delivery</h3>
                <p>
                  Our professional drivers deliver your order discreetly. 
                  All transactions follow DC's I-71 gifting regulations.
                </p>
              </div>
            </div>

            <div className="step-card">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Enjoy Responsibly</h3>
                <p>
                  Consume safely on private property. Store securely away 
                  from children and pets.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Safety & Responsibility */}
      {/* <section className="section safety-section">
        <div className="container">
          <div className="safety-content">
            <div className="safety-header">
              <h2 className="section-title">Safety & Responsibility</h2>
              <p className="section-subtitle">Our commitment to community wellbeing</p>
            </div>

            <div className="safety-grid">
              <div className="safety-card">
                <div className="safety-icon">🧪</div>
                <h3>Lab Tested Products</h3>
                <p>
                  All products are third-party lab tested for potency and purity. 
                  No pesticides, heavy metals, or contaminants.
                </p>
              </div>

              <div className="safety-card">
                <div className="safety-icon">👨‍👩‍👧‍👦</div>
                <h3>Community Education</h3>
                <p>
                  We provide educational resources about responsible consumption, 
                  safe storage, and DC cannabis laws.
                </p>
              </div>

              <div className="safety-card">
                <div className="safety-icon">🚗</div>
                <h3>Safe Delivery</h3>
                <p>
                  Professional drivers with clean records. Discreet, unmarked 
                  vehicles for your privacy and security.
                </p>
              </div>

              <div className="safety-card">
                <div className="safety-icon">🔞</div>
                <h3>Age Verification</h3>
                <p>
                  Strict 21+ policy enforced. Valid photo ID required at 
                  delivery. No exceptions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* FAQ Section */}
      <section className="section faq-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Frequently Asked Questions</h2>
            <p className="section-subtitle">Common questions about I-71 and our service</p>
          </div>

          <div className="faq-grid">
            <div className="faq-card">
              <h3>Is this legal?</h3>
              <p>
                Yes. We operate in full compliance with Washington DC's 
                Initiative 71. We provide cannabis as gifts with the purchase 
                of our delivery service and educational materials.
              </p>
            </div>

            <div className="faq-card">
              <h3>Do I need to be 21?</h3>
              <p>
                Yes. You must be 21 years or older with valid government-issued 
                photo ID. We verify age at the time of delivery.
              </p>
            </div>

            <div className="faq-card">
              <h3>What areas do you deliver to?</h3>
              <p>
                We deliver throughout Washington DC Area.
              </p>
            </div>

            <div className="faq-card">
              <h3>How long does delivery take?</h3>
              <p>
                Most deliveries within DC are completed within 1 hour. 
                You'll receive real-time updates about your driver's ETA.
              </p>
            </div>

            <div className="faq-card">
              <h3>Can I Schedule a Delivery?</h3>
              <p>
                Yes you can schedule a deliver or curb side pick-up by text/call (202) 476-9173.
              </p>
            </div>

            <div className="faq-card">
              <h3>Is delivery discreet?</h3>
              <p>
                Yes. Our drivers use unmarked vehicles and professional 
                packaging. Your privacy and security are our top priorities.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Age Verification Banner */}
      <section className="age-verification-banner">
        <div className="container">
          <div className="banner-content">
            <div className="banner-icon">🔞</div>
            <div className="banner-text">
              <h3>Age 21+ Verification Required</h3>
              <p>
                By using our service, you confirm that you are 21 years of age 
                or older. You must present valid government-issued photo ID 
                at delivery. It is illegal to share cannabis with minors.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Experience Premium Cannabis?</h2>
            <p className="cta-subtitle">
              Browse our selection of premium products delivered legally to your door
            </p>
            <div className="cta-actions">
              <button 
                onClick={handleShopNowClick}
                className="btn btn-primary btn-lg"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  fontSize: '1rem',
                  fontWeight: '600',
                  padding: 'var(--space-md) var(--space-xl)',
                  border: 'none',
                  borderRadius: 'var(--radius-lg)',
                  backgroundColor: 'var(--primary)',
                  color: 'white',
                  transition: 'all 0.2s ease',
                  textDecoration: 'none',
                  textAlign: 'center'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--primary-dark)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--primary)'}
              >
                🛍️ Shop Now
              </button>
              
            </div>
          </div>
        </div>
      </section>

      {/* Legal Disclaimer */}
      <section className="legal-disclaimer">
        <div className="container">
          <div className="disclaimer-content">
            <h3>Legal Disclaimer</h3>
            <p>*InAndOutDC operates in compliance with Washington DC Initiative 71. Cannabis is provided as a gift with the purchase of legal products. Must be 21+ to participate. Please consume responsibly and in accordance with DC laws.</p>
            {/* <p className="disclaimer-note">
              By using our service, you acknowledge that you understand and agree 
              to comply with all applicable DC laws and regulations.
            </p> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;